import Workflow from "./workflow/Workflow"
import { observer } from "mobx-react-lite"
import { AlertModal } from '../../../../..'
import Panel from "../../../../layout/Panel"
import { DetailPanelProps } from "../DetailPanel"
import { store } from "../../../../../stores/Store"
import PanelBody from "../../../../layout/PanelBody"
import TruncText from '../../../../../misc/TruncText'
import PanelLabel from "../../../../layout/PanelLabel"
import { Questionnaire, Workflow as IWorkflow } from '../../../../../models/Interfaces'
import ViewQuestionnaire from '../../../questionnaire/ViewQuestionnaire'
import CaseDetailForm from "./CaseDetailForm"
import React from "react"
import { Icons } from "../../../../../misc/Icons"
import { Theme } from "../../../../../misc/Theme"
import Ajax from "../../../../../Ajax"
import WorkflowCreateForm from "./workflow/WorkflowCreateForm"


export default observer(function CaseDetail ({index}: DetailPanelProps) {

    const { loadingLeafNode, folderNode } = store.NodeStore
    const showWorkflow = store.AppStore.sessionInfo?.accountPreferences?.default_case_workflow !== "NONE"

    return (
        <Panel index={index} id="DETAIL" className="detail case-detail" width="100%" loadingContent={loadingLeafNode}>

            <PanelLabel title="Details" />

            <PanelBody>
                <div style={{width: "100%", height: "100%", overflowY: "auto", paddingBottom: "30px"}}>
                    <div className="panel-columns" style={{width: "100%", maxWidth: "900px", margin: "0 auto", gridTemplateColumns: "500px auto", gap: "20px", padding: "30px 10px 0 0", boxSizing: "border-box"}}>
                        <div className="panel-column" style={{padding: 0}}>
                            {showWorkflow ? (
                                <Workflow caseNode={folderNode} />
                            ) : null}

                            <CaseQuestionnaires caseNode={folderNode} />
                        </div>

                        <div className="panel-column" style={{padding: 0}}>
                            <CaseDetailForm caseNode={folderNode} />

                            {typeof folderNode.tags === "object" && Object.keys(folderNode.tags).length ? (
                                <div>
                                    <h3>Case Tags</h3>
                                    
                                    <div className="code font-grey">
                                        {Object.keys(folderNode.tags).map(key => (
                                            <div style={{display: "grid", gridTemplateColumns: "49% 49%", gap: "2%", rowGap: "4px"}}>
                                                <span>{key}</span>
                                                <span>{folderNode.tags[key]}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </PanelBody>

        </Panel>
    )
})


function CaseQuestionnaires ({caseNode}) {

    if (!store.AppStore.sessionInfo.accountPreferences.integration_api_enabled) return <></>

    var questionnaires: Questionnaire[] = store.QuestionnaireStore.filterQuestionnairesByTags(caseNode.tags)

    return (
        <div>
            <h3>Linked Questionnaires</h3>

            {questionnaires?.length ? (
                <div style={{display: "grid", gridTemplateColumns: "75px 75px 200px auto", gap: "10px", alignItems: "center", margin: "5px"}}>

                    <span style={{borderBottom: "0.5px solid grey"}}>Preloaded</span>
                    <span style={{borderBottom: "0.5px solid grey"}}>Submitted</span>
                    <span style={{borderBottom: "0.5px solid grey"}}>Display name</span>
                    <span style={{borderBottom: "0.5px solid grey"}}>Template</span>

                    {questionnaires?.map((questionnaire, i) => (
                        <React.Fragment key={i}>
                            {questionnaire.preloadedAnswersCount 
                                ? <div>{questionnaire.preloadedAnswersCount}</div>
                                : <div className="font-grey">-</div>}

                            <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                                {questionnaire.percentageComplete 
                                    ? <div>{questionnaire.percentageComplete}%</div>
                                    : <div className="font-grey">0%</div>}
                                {questionnaire.locked ? <Icons.Lock style={{fontSize: "12px", marginLeft: "auto", color: Theme.palette.success.main}} /> : null}
                            </div>

                            <div className="link" style={{width: "auto"}} onClick={() => AlertModal({body: <ViewQuestionnaire uid={questionnaire.uid} />, width: "700px"})}>
                                <TruncText text={questionnaire.displayName} />
                            </div>

                            <div>
                                <TruncText text={questionnaire.template.displayName} />
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                <p>This Case hasn't got any linked Questionnaires.</p>
            )}
        </div>
    )
}